import { Identifiable } from "./identifiable";
import { Status, status } from "./status";
import { Allocation } from "./allocation";
import { Tag } from "./tag";
import { id } from "./id";
import { Attachment } from "./attachment";

type Task = {
  name: string;
  description: string;
  startDate: string;
  endDate: string;
  createdDate: string;
  completionDate: string;
  percentComplete: number;
  allocations: Identifiable<Allocation>[];
  status: Identifiable<Status>;
  tags: Tag[];
  attachments?: Identifiable<Attachment>[];
  commentsNbr?: number;
  attachmentsNbr?: number;
  activityKeyRank: number;
  statusKeyRank: number;
  duration: number;
  attributes?: { [key: string]: string };
  minStartDate: string;
  maxEndDate: string;
  lastModified: string;
};

const task: Task = {
  name: "",
  completionDate: "",
  description: "",
  createdDate: "",
  startDate: "",
  endDate: "",
  percentComplete: 0,
  allocations: [],
  tags: [],
  status: { ...status, uuid: id },
  activityKeyRank: 0,
  statusKeyRank: 0,
  duration: 0,
  minStartDate: "",
  maxEndDate: "",
  lastModified: "",
};

export type { Task };

export { task };
